import React, { useEffect, useMemo, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Typography } from '@material-ui/core';
import apiRoutes from '../../../../config/api/routes';
import { useFetch } from '../../../shared/hooks';
import { Filter } from '../../../shared/components';
import { FilterOption } from '../../../shared/components/Filter';
import AssignmentCardHeader from './AssignmentCardHeader';
import AssignmentsList from './AssignmentsList';
import { IUserBook } from 'src/config/api/models/Book';

const AssignmentCard = () => {
  const { t } = useTranslation();

  const [{ bookFilter, groupFilter }, patchFilters] = useReducer(
    (state: { [key: string]: string }, patch: { [key: string]: string }) => {
      if (patch.bookFilter === '') return { bookFilter: '', groupFilter: '' };
      return { ...state, ...patch };
    },
    { bookFilter: '', groupFilter: '' }
  );
  const [booksResponse, getBooks] = useFetch<IUserBook[]>(apiRoutes.booksByUser());
  useEffect(getBooks, [getBooks]);

  const books: FilterOption[] = useMemo(() => {
    if (!booksResponse.success) return [];

    return booksResponse.data.map(({ id, title }) => ({ id, label: title }));
  }, [booksResponse]);

  const groups: FilterOption[] = useMemo(() => {
    if (!booksResponse.success) return [];

    const groupsByBook = booksResponse.data.find((book) => book.id === bookFilter)?.groups;

    return groupsByBook?.map(({ id, name }) => ({ id, label: name })) ?? [];
  }, [bookFilter, booksResponse]);

  return (
    <>
      <Paper elevation={0}>
        <AssignmentCardHeader>
          <Typography className="prefix" variant="h3">
            {t('assignmentDashboard.openTasks')}
          </Typography>
          <Filter
            id="subject-filter"
            label={t('shared.forms.subject')}
            value={bookFilter}
            onChange={(bookFilter) => patchFilters({ bookFilter, groupFilter: '' })}
            placeholder={t('shared.forms.allSubjects')}
            options={books}
            emptyOption
          />
          <Filter
            id="grade-filter"
            label={t('shared.forms.grade')}
            value={groupFilter}
            onChange={(groupFilter) => patchFilters({ groupFilter })}
            options={groups}
            placeholder={t('shared.forms.allGrades')}
            disabled={!bookFilter}
            emptyOption
          />
        </AssignmentCardHeader>
      </Paper>
      <AssignmentsList bookFilter={bookFilter} groupFilter={groupFilter} />
    </>
  );
};

export default AssignmentCard;
